export const Set_Name = value => {
    window.localStorage.setItem('name', value.fullName);
};
